import isEmpty from "lodash-es/isEmpty";
import isFinalState from "../uploadItemStatus/isFinalState";
const isFileProcessingFinished = (items) => {
    return isEmpty(items)
        ? true
        : isEmpty(items.find((el) => !isFinalState(el.status)));
};
export default isFileProcessingFinished;
